const TypefaceIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="52"
      height="53"
      viewBox="0 0 52 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_6_30141)">
        <path
          opacity="0.2"
          d="M15.36 22.5321V33.1988H7.67999V38.5321H16.64H32V33.1988V22.5321H15.36Z"
          fill="white"
        />
        <path
          d="M15.36 22.5321H32"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M15.36 27.8651H32"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M7.67999 33.1991H32"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M7.67999 38.5321H32"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M15.36 17.1988V14.5321H0V17.1988"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M5.11969 27.8651H10.2397"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M7.67999 14.5321V27.8654"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_30141">
          <path
            d="M0 8.5321C0 4.11383 3.58172 0.532104 8 0.532104H44C48.4183 0.532104 52 4.11383 52 8.5321V44.5321C52 48.9504 48.4183 52.5321 44 52.5321H8C3.58172 52.5321 0 48.9504 0 44.5321V8.5321Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TypefaceIcon;
